import { BrowserRouter as Router, Routes, Route, Navigate, Outlet } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import { HelmetProvider } from 'react-helmet-async';
import { Toaster } from 'sonner';

// Components
import Navbar from './components/Navbar';
import Footer from './components/Footer';

// Pages
import TumansiLanding from './pages/Tumanasi/TumansiLanding';
import TumansiPricing from './pages/Tumanasi/TumansiPricing';
import BookingWizard from './pages/Tumanasi/BookingWizard';
import TrackDelivery from './pages/Tumanasi/TrackDelivery';
import RiderRegister from './pages/Tumanasi/RiderRegister';
import RiderDashboard from './pages/Tumanasi/RiderDashboard';
import TumansiAdmin from './pages/Tumanasi/TumansiAdmin';
import Login from './pages/Login';
import Signup from './pages/Signup';

// Layout wrapper with Navbar and Footer
function Layout() {
  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}

// Protected Route Component
function ProtectedRoute({ children }) {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600"></div>
      </div>
    );
  }

  return isAuthenticated ? children : <Navigate to="/login" replace />;
}

// Admin Route Component
function AdminRoute({ children }) {
  const { user, isAuthenticated, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600"></div>
      </div>
    );
  }

  if (!isAuthenticated || (user?.role?.toLowerCase() !== 'admin' && user?.user_type?.toLowerCase() !== 'admin')) {
    return <Navigate to="/" replace />;
  }

  return children;
}

function App() {
  return (
    <HelmetProvider>
      <AuthProvider>
        <Toaster richColors position="top-right" />
        <Router>
          <Routes>
            {/* Auth routes - no layout */}
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />

            {/* All other routes with Navbar/Footer */}
            <Route element={<Layout />}>
              {/* Public routes */}
              <Route path="/" element={<TumansiLanding />} />
              <Route path="/pricing" element={<TumansiPricing />} />
              <Route path="/book" element={<BookingWizard />} />
              <Route path="/track" element={<TrackDelivery />} />
              <Route path="/track/:trackingNumber" element={<TrackDelivery />} />

              {/* Rider routes */}
              <Route path="/rider/register" element={<RiderRegister />} />
              <Route path="/rider/dashboard" element={
                <ProtectedRoute>
                  <RiderDashboard />
                </ProtectedRoute>
              } />
            </Route>

            {/* Admin routes - standalone without navbar/footer */}
            <Route path="/admin" element={
              <AdminRoute>
                <TumansiAdmin />
              </AdminRoute>
            } />

            {/* Catch-all redirect */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </Router>
      </AuthProvider>
    </HelmetProvider>
  );
}

export default App;
